/**
 * Subphase change email triggers (commercial + expansion projects).
 * Trigger ids: subphase_<phaseKey>_<slug> (e.g. subphase_drafting_in_progress).
 */
import { SUBPHASE_LABELS, SUBPHASE_SLUGS_BY_PHASE } from "./commercialSubphases";
import { EXPANSION_SUBPHASE_SLUGS_BY_PHASE } from "./expansionProjectSchema";

/** @type {{ id: string, label: string, group: string }[]} */
export const SUBPHASE_EMAIL_TRIGGER_DEFINITIONS = [];

const seenTriggerIds = new Set();

function registerSubphaseTriggers(slugsByPhase) {
  for (const [phaseLabel, slugs] of Object.entries(slugsByPhase)) {
    const phaseKey = String(phaseLabel).trim().toLowerCase();
    for (const slug of slugs) {
      const id = `subphase_${phaseKey}_${slug}`;
      if (seenTriggerIds.has(id)) continue;
      seenTriggerIds.add(id);
      const subLabel = SUBPHASE_LABELS[slug] || slug.replace(/_/g, " ");
      SUBPHASE_EMAIL_TRIGGER_DEFINITIONS.push({
        id,
        label: `${phaseLabel} — ${subLabel}`,
        group: "Subphase changes",
      });
    }
  }
}

registerSubphaseTriggers(SUBPHASE_SLUGS_BY_PHASE);
registerSubphaseTriggers(EXPANSION_SUBPHASE_SLUGS_BY_PHASE);

export const SUBPHASE_EMAIL_TRIGGER_IDS = SUBPHASE_EMAIL_TRIGGER_DEFINITIONS.map((d) => d.id);
